import { render, staticRenderFns } from "./Historyfilter.vue?vue&type=template&id=08512b1f&scoped=true"
import script from "./Historyfilter.vue?vue&type=script&lang=js"
export * from "./Historyfilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08512b1f",
  null
  
)

export default component.exports